/* eslint-disable no-unused-vars */

import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import api from "../../api/api";
import Style from "../../assets/css/main.module.css";
import { drawerAction } from "../../store/features/deviceSlice";
import Loader from "../loader/Loader";
import Membership from "./Membership";
import Package from "./Package";
import Ticket from "./Ticket";

export default function Tickets() {
  const dispatch = useDispatch();
  const [tab, setTab] = useState("active");
  const [general, setGeneral] = useState([]);
  const [packages, setPackages] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [type, setType] = useState("active");
  const [loading, setLoading] = useState(false);
  const fetch = useCallback(async () => {
    setLoading(true);
    let res;
    if (tab === "active") {
      res = await api.activeTicket();
      setType("active");
    } else {
      res = await api.expiredTicket();
      setType("expired");
    }
    if (res.status === 200) {
      setGeneral(res.data.data.general);
      setPackages(res.data.data.packages);
      setMemberships(res.data.data.memberships);
    }
    setLoading(false);
  }, [tab]);

  useEffect(() => {
    fetch();
  }, [fetch]);
  return (
    <div className="w-100 h-100 px-2 px-md-4">
      <div className="profile-container overflow-y-scroll pt-3 pb-5">
        <div className="d-flex gap-2 pb-2">
          <div className="w-50">
            <button
              type="button"
              onClick={() => setTab("active")}
              className={
                tab === "active"
                  ? `${Style.bg_primary} ${Style.fw_350} ${Style.fs_20} border-0 rounded w-100 text-light p-3 d-flex align-items-center justify-content-center save-btn`
                  : `${Style.bg_gray_200} ${Style.border_secondary_500} ${Style.text_secondary_500} ${Style.fw_350} ${Style.fs_20} p-3 border-0 rounded w-100 d-flex align-items-center justify-content-center save-btn`
              }
            >
              Active
            </button>
          </div>
          <div className="w-50">
            <button
              type="button"
              onClick={() => setTab("expired")}
              className={
                tab === "expired"
                  ? `${Style.bg_primary} ${Style.fw_350} ${Style.fs_20} border-0 rounded w-100 text-light p-3 d-flex align-items-center justify-content-center save-btn`
                  : `${Style.bg_gray_200} ${Style.border_secondary_500} ${Style.text_secondary_500} ${Style.fw_350} ${Style.fs_20} p-3 border-0 rounded w-100  d-flex align-items-center justify-content-center save-btn`
              }
            >
              Expired
            </button>
          </div>
        </div>
        {loading && (
          <div className="w-100 h-100 d-flex justify-content-center">
            <Loader />
          </div>
        )}
        {!loading && (
          <>
            {packages.length > 0 && (
              <>
                <div
                  className={`${Style.fs_20} ${Style.fw_600} ${Style.text_primary}`}
                >
                  Packages
                </div>
                {packages.map((item) => (
                  <Package key={Math.random()} item={item} type={type} />
                ))}
              </>
            )}
            {memberships.length > 0 && (
              <>
                <div
                  className={`${Style.fs_20} ${Style.fw_600} ${Style.text_primary}`}
                >
                  Memberships
                </div>
                {memberships.map((item) => (
                  <Membership key={Math.random()} item={item} type={type} />
                ))}
              </>
            )}
            {general.length > 0 && (
              <>
                <div
                  className={`${Style.fs_20} ${Style.fw_600} ${Style.text_primary}`}
                >
                  General Tickets
                </div>
                {general.map((item) => (
                  <Ticket key={Math.random()} item={item} type={type} />
                ))}
              </>
            )}
          </>
        )}
      </div>
      <div
        className="profile-bottom mb-3 w-100"
        style={{ position: "absolute", bottom: 0, zIndex: 10 }}
      >
        <button
          type="button"
          onClick={() => dispatch(drawerAction(false))}
          className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light py-1 profile-back-btn rounded`}
          style={{ width: "90%" }}
        >
          Back
        </button>
      </div>
    </div>
  );
}
